import getInternationalPhoneNumberPrefix from "./getInternationalPhoneNumberPrefix.js";
import parsePhoneNumber$1 from "../../../libphonenumber-js/es6/parsePhoneNumber.js";
import Metadata, { getCountryCallingCode } from "../../../libphonenumber-js/es6/metadata.js";
import AsYouType from "../../../libphonenumber-js/es6/AsYouType.js";
function getPreSelectedCountry(_ref) {
  var value = _ref.value, phoneNumber = _ref.phoneNumber, defaultCountry = _ref.defaultCountry, getAnyCountry = _ref.getAnyCountry, countries = _ref.countries, required = _ref.required, metadata = _ref.metadata, country;
  return phoneNumber && phoneNumber.country ? country = phoneNumber.country : defaultCountry && (!value || couldNumberBelongToCountry(value, defaultCountry, metadata)) && (country = defaultCountry), countries && countries.indexOf(country) < 0 && (country = void 0), !country && required && countries && countries.length > 0 && (country = getAnyCountry()), country;
}
function getCountrySelectOptions(_ref2) {
  var countries = _ref2.countries, countryNames = _ref2.countryNames, addInternationalOption = _ref2.addInternationalOption, compareStringsLocales = _ref2.compareStringsLocales, _compareStrings = _ref2.compareStrings;
  _compareStrings || (_compareStrings = compareStrings);
  var countrySelectOptions = countries.map(function(country) {
    return {
      value: country,
      // All `locale` country names included in this library
      // include all countries (this is checked at build time).
      // The only case when a country name might be missing
      // is when a developer supplies their own `labels` property.
      // To guard against such cases, a missing country name
      // is substituted by country code.
      label: countryNames[country] || country
    };
  });
  return countrySelectOptions.sort(function(a, b) {
    return _compareStrings(a.label, b.label, compareStringsLocales);
  }), addInternationalOption && countrySelectOptions.unshift({
    label: countryNames.ZZ
  }), countrySelectOptions;
}
function parsePhoneNumber(value, metadata) {
  return parsePhoneNumber$1(value || "", metadata);
}
function generateNationalNumberDigits(phoneNumber) {
  return phoneNumber.formatNational().replace(/\D/g, "");
}
function getPhoneDigitsForNewCountry(phoneDigits, _ref3) {
  var prevCountry = _ref3.prevCountry, newCountry = _ref3.newCountry, metadata = _ref3.metadata, useNationalFormat = _ref3.useNationalFormat;
  if (prevCountry === newCountry)
    return phoneDigits;
  if (!phoneDigits)
    return useNationalFormat ? "" : newCountry ? getInternationalPhoneNumberPrefix(newCountry, metadata) : "";
  if (newCountry) {
    if (phoneDigits[0] === "+") {
      if (useNationalFormat)
        return phoneDigits.indexOf("+" + getCountryCallingCode(newCountry, metadata)) === 0 ? stripCountryCallingCode(phoneDigits, newCountry, metadata) : "";
      if (prevCountry) {
        var newCountryPrefix = getInternationalPhoneNumberPrefix(newCountry, metadata);
        return phoneDigits.indexOf(newCountryPrefix) === 0 ? phoneDigits : newCountryPrefix;
      } else {
        var defaultValue = getInternationalPhoneNumberPrefix(newCountry, metadata);
        return phoneDigits.indexOf(defaultValue) === 0 ? phoneDigits : defaultValue;
      }
    }
  } else if (phoneDigits[0] !== "+")
    return e164(phoneDigits, prevCountry, metadata) || "";
  return phoneDigits;
}
function e164(number, country, metadata) {
  if (number) {
    if (number[0] === "+") {
      if (number === "+")
        return;
      var asYouType = new AsYouType(country, metadata);
      return asYouType.input(number), asYouType.getNumberValue();
    }
    if (country) {
      var partial_national_significant_number = getNationalSignificantNumberDigits(number, country, metadata);
      return "+".concat(getCountryCallingCode(country, metadata)).concat(partial_national_significant_number || "");
    }
  }
}
function trimNumber(number, country, metadata) {
  var nationalSignificantNumberPart = getNationalSignificantNumberDigits(number, country, metadata);
  if (nationalSignificantNumberPart) {
    var overflowDigitsCount = nationalSignificantNumberPart.length - getMaxNumberLength(country, metadata);
    if (overflowDigitsCount > 0)
      return number.slice(0, number.length - overflowDigitsCount);
  }
  return number;
}
function getMaxNumberLength(country, metadata) {
  return metadata = new Metadata(metadata), metadata.selectNumberingPlan(country), metadata.numberingPlan.possibleLengths()[metadata.numberingPlan.possibleLengths().length - 1];
}
function getCountryForPartialE164Number(partialE164Number, _ref4) {
  var country = _ref4.country, countries = _ref4.countries, required = _ref4.required, metadata = _ref4.metadata;
  if (partialE164Number === "+")
    return country;
  var derived_country = getCountryFromPossiblyIncompleteInternationalPhoneNumber(partialE164Number, metadata);
  return derived_country && (!countries || countries.indexOf(derived_country) >= 0) ? derived_country : country && !required && !couldNumberBelongToCountry(partialE164Number, country, metadata) ? void 0 : country;
}
function onPhoneDigitsChange(phoneDigits, _ref5) {
  var prevPhoneDigits = _ref5.prevPhoneDigits, country = _ref5.country, defaultCountry = _ref5.defaultCountry, countryRequired = _ref5.countryRequired, getAnyCountry = _ref5.getAnyCountry, countries = _ref5.countries, international = _ref5.international, limitMaxLength = _ref5.limitMaxLength, countryCallingCodeEditable = _ref5.countryCallingCodeEditable, metadata = _ref5.metadata;
  if (international && countryCallingCodeEditable === !1 && country) {
    var prefix = getInternationalPhoneNumberPrefix(country, metadata);
    if (phoneDigits.indexOf(prefix) !== 0) {
      var _value, hasStartedTypingInNationalNumberDigitsHavingInputValueSelected = phoneDigits && phoneDigits[0] !== "+";
      return hasStartedTypingInNationalNumberDigitsHavingInputValueSelected ? (phoneDigits = prefix + phoneDigits, _value = e164(phoneDigits, country, metadata)) : phoneDigits = prefix, {
        phoneDigits,
        value: _value,
        country
      };
    }
  }
  international === !1 && country && phoneDigits && phoneDigits[0] === "+" && (phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata)), phoneDigits && country && limitMaxLength && (phoneDigits = trimNumber(phoneDigits, country, metadata)), phoneDigits && phoneDigits[0] !== "+" && (!country || international) && (phoneDigits = "+" + phoneDigits), !phoneDigits && prevPhoneDigits && prevPhoneDigits[0] === "+" && (international ? country = void 0 : country = defaultCountry), phoneDigits === "+" && prevPhoneDigits && prevPhoneDigits[0] === "+" && prevPhoneDigits.length > 1 && (country = void 0);
  var value;
  return phoneDigits && (phoneDigits[0] === "+" && (phoneDigits === "+" || country && getInternationalPhoneNumberPrefix(country, metadata).indexOf(phoneDigits) === 0) ? value = void 0 : value = e164(phoneDigits, country, metadata)), value && (country = getCountryForPartialE164Number(value, {
    country,
    countries,
    metadata
  }), international === !1 && country && phoneDigits && phoneDigits[0] === "+" && (phoneDigits = convertInternationalPhoneDigitsToNational(phoneDigits, country, metadata), value = e164(phoneDigits, country, metadata))), !country && countryRequired && (country = defaultCountry || getAnyCountry()), {
    // `phoneDigits` returned here are a "normalized" version of the original `phoneDigits`.
    // The returned `phoneDigits` shouldn't be used anywhere except for passing it as
    // `prevPhoneDigits` parameter to this same function on next input change event.
    phoneDigits,
    country,
    value
  };
}
function convertInternationalPhoneDigitsToNational(input, country, metadata) {
  if (input.indexOf(getInternationalPhoneNumberPrefix(country, metadata)) === 0) {
    var formatter = new AsYouType(country, metadata);
    formatter.input(input);
    var phoneNumber = formatter.getNumber();
    return phoneNumber ? phoneNumber.formatNational().replace(/\D/g, "") : "";
  } else
    return input.replace(/\D/g, "");
}
function getCountryFromPossiblyIncompleteInternationalPhoneNumber(number, metadata) {
  var formatter = new AsYouType(null, metadata);
  return formatter.input(number), formatter.getCountry();
}
function compareStrings(a, b, locales) {
  return String.prototype.localeCompare ? a.localeCompare(b, locales) : a < b ? -1 : a > b ? 1 : 0;
}
function stripCountryCallingCode(number, country, metadata) {
  if (country) {
    var countryCallingCodePrefix = "+" + getCountryCallingCode(country, metadata);
    if (number.length < countryCallingCodePrefix.length) {
      if (countryCallingCodePrefix.indexOf(number) === 0)
        return "";
    } else if (number.indexOf(countryCallingCodePrefix) === 0)
      return number.slice(countryCallingCodePrefix.length);
  }
  for (var _i = 0, _Object$keys = Object.keys(metadata.country_calling_codes); _i < _Object$keys.length; _i++) {
    var country_calling_code = _Object$keys[_i];
    if (number.indexOf(country_calling_code) === 1)
      return number.slice(1 + country_calling_code.length);
  }
  return "";
}
function getNationalSignificantNumberDigits(number, country, metadata) {
  var formatter = new AsYouType(country, metadata);
  formatter.input(number);
  var phoneNumber = formatter.getNumber();
  return phoneNumber && phoneNumber.nationalNumber;
}
function couldNumberBelongToCountry(number, country, metadata) {
  for (var intlPhoneNumberPrefix = getInternationalPhoneNumberPrefix(country, metadata), i = 0; i < number.length && i < intlPhoneNumberPrefix.length; ) {
    if (number[i] !== intlPhoneNumberPrefix[i])
      return !1;
    i++;
  }
  return !0;
}
function getInitialPhoneDigits(_ref6) {
  var value = _ref6.value, phoneNumber = _ref6.phoneNumber, defaultCountry = _ref6.defaultCountry, international = _ref6.international, useNationalFormat = _ref6.useNationalFormat, metadata = _ref6.metadata;
  return (international === !1 || useNationalFormat) && phoneNumber && phoneNumber.country ? generateNationalNumberDigits(phoneNumber) : !value && international && defaultCountry ? getInternationalPhoneNumberPrefix(defaultCountry, metadata) : value;
}
export {
  compareStrings,
  couldNumberBelongToCountry,
  e164,
  generateNationalNumberDigits,
  getCountryForPartialE164Number,
  getCountryFromPossiblyIncompleteInternationalPhoneNumber,
  getCountrySelectOptions,
  getInitialPhoneDigits,
  getNationalSignificantNumberDigits,
  getPhoneDigitsForNewCountry,
  getPreSelectedCountry,
  onPhoneDigitsChange,
  parsePhoneNumber,
  stripCountryCallingCode,
  trimNumber
};
//# sourceMappingURL=phoneInputHelpers.js.map
